import { AbstractDownloadableService } from "./abstract-downloadable.service";
import { Subscription } from "../models";

/**
 * @class SubscriptionPmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<Subscription>}
 */
export class SubscriptionPmsApiService extends AbstractDownloadableService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/subscription(/:id)';
    }

    get urlPatternWithProperty() {

        return '/billing/property/:propertyId/subscription(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {Subscription}
     * @protected
     */
    newModel(attributes, ...params) {

        return new Subscription(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<Subscription>>}
     */
    get (params = {}) {

        const url = this.url() + '-index';

        return this.http
            .post(url, params,{
                headers: this.authHeaders,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Subscription} subscription
     * @returns {Promise.<Subscription>}
     */
    create(subscription) {

        const url = this.url();

        return this.http
            .post(url, subscription.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Subscription} subscription
     * @returns {Promise.<Subscription>}
     */
    update(subscription) {

        const url = this.url({id: subscription.id});

        return this.http
            .put(url, subscription.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {integer} subscriptionId
     * @returns {Promise.<Subscription>}
     */
    show(subscriptionId) {

        const url = this.url({
            id: subscriptionId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Subscription} subscription
     * @param {String} status
     * @returns {Promise.<Subscription>}
     */
    updateStatus(subscription, status) {

        const url = this.url({
            id: subscription.id
        }) + '/update-status';

        return this.http
            .post(url, {status: status}, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Subscription} subscription
     * @returns {Promise.<Subscription[]>}
     */
    recentAcvitity(subscription, lang) {

        const url = this.url({
            id: subscription.id
        }) + '/recent-activity';

        return this.http
            .post(url, {lang},{
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param property
     * @return {*}
     */
    showActive(property) {

        const url = this.url({
            propertyId: property.id,
        }, this.urlPatternWithProperty) + '/active';

        return this.http
            .get(url, {
                headers: this.authHeaders,
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param property
     * @return {*}
     */
    showLastCreated(property) {

        const url = this.url({
            propertyId: property.id,
        }, this.urlPatternWithProperty) + '/last-created';

        return this.http
            .get(url, {
                headers: this.authHeaders,
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    exportPDF(params = {}) {

        const url = this.url() + '/export-pdf';

        return this.download(url, params, 'Subscriptions.pdf');
    }

    exportExcel(params = {}) {

        const url = this.url() + '/export-excel';

        return this.download(url, params, 'Subscriptions.xls');
    }

    exportCSV(params = {}) {

        const url = this.url() + '/export-csv';

        return this.download(url, params, 'Subscriptions.csv');
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/subscription.service.js